
import { KeyboardInput } from "./KeyboardInput.js";
import { MouseInput } from "./MouseInput.js";
import { TouchInput } from "./TouchInput.js";
import { AccelerometerInput } from "./AccelerometerInput.js";
import { GyroscopeInput } from "./GyroscopeInput.js";
import { XRInput } from "./XRInput.js";


/**
 * Provides a global unique interface for capturing and managing input events.
 */
export class Input {
    static _keyboardInput = {};
    static _mouseInput = {};
    static _touchInput = {};
    static _accelerometerInput = {};
    static _gyroscopeInput = {};
    static _xrInput = {};

    static setup(renderer) {
        if (!renderer) {
            console.warn('Renderer is null or undefined. Input setup aborted.');
            return;
        }
        Input._keyboardInput = new KeyboardInput();
        Input._mouseInput = new MouseInput(renderer);
        Input._touchInput = new TouchInput(renderer);
        Input._xrInput = new XRInput(renderer);
        Input._accelerometerInput = new AccelerometerInput();
        Input._gyroscopeInput = new GyroscopeInput();
    }

    /**
     *  Access to the KeyboardInput interface.
     */
    static get keyboard() {
        return Input._keyboardInput;
    }

    /**
     * Access to the MouseInput interface.
     */
    static get mouse() {
        return Input._mouseInput;
    }

    /**
    * Access to the TouchInput interface.
    */
    static get touch() {
        return Input._touchInput;
    }

    /**
    * Access to the AccelerometerInput interface.
    */
    static get accelerometer() {
        return Input._accelerometerInput;
    }

    /**
    * Access to the GyroscopeInput interface.
    */
    static get gyroscope() {
        return Input._gyroscopeInput;
    }

    /**
    * Access to the XRInput interface.
    */
    static get xr() {
        return Input._xrInput;
    }

    static eventAllFrameEnd() {
        Input.keyboard.eventFrameEnd();
        Input.mouse.eventFrameEnd();
        Input.touch.eventFrameEnd();
        Input.xr.eventFrameEnd();
        Input.accelerometer.eventFrameEnd();
        Input.gyroscope.eventFrameEnd();
    }
}
